import useSearchParams from "hooks/useSearchParams"
import BaseEncoder from "utils/base-encoder"
function useOrderIds() {
  const [params] = useSearchParams<{ ords: string }>()
  const orderStrings = params.ords
  return BaseEncoder.decode(orderStrings)
    ?.split(",")
    .map(a => parseInt(a))
    .filter(a => a)
}

export default useOrderIds
